import moment from 'moment';

export const formatDate = ({ date, format }) => {
    return moment(Number(date)).format(format);
};
